export default __webpack_public_path__ + "static/media/google-checkbox-required.506c8cb7.png";